import { Organization } from '@/types/Organization';
import { Service } from './Service';

export interface Request {
  id: string;
  Reference: string;
  refNo?: string;
  category: string;
  description?: string;
  assistanceType?: AssistanceTypeStatus;
  isAnonymous?: IsAnonymousType;
  contact?: string;
  organizationId: string;
  organization?: Organization;
  senderName: string;
  senderPhone: string;
  comments?: string;
  message?: string;
  files?: string[];
  status: RequestStatus;
  serviceId: string;
  service?: Service;
  createdAt: string;
  updatedAt: string;
  provinceId?: number;
  districtId?: number;
  sectorId?: number;
  province?: {
    id: number;
    name: string;
  };
  district?: {
    id: number;
    name: string;
  };
  sector?: {
    id: number;
    name: string;
  };
}

export enum IsAnonymousType {
  Yes = 'Yes',
  No = 'No',
}

export enum AssistanceTypeStatus {
  Online = 'Online',
  Person = 'Person',
}

export enum RequestStatus {
  InProgress = 'InProgress',
  Pending = 'Pending',
  Resolved = 'Resolved',
  Referred = 'Referred',
}

export const statusBgColorMapping: Record<RequestStatus, string> = {
  [RequestStatus.InProgress]: 'bg-lime-100 text-lime-900',
  [RequestStatus.Pending]: 'bg-yellow-100 text-yellow-500',
  [RequestStatus.Referred]: 'bg-blue-100 text-blue-800',
  [RequestStatus.Resolved]: 'bg-purple-100 text-purple-800',
};

export type AuthRequest = Pick<Request, 'id' | 'Reference'>;

export interface GetRequestsArgs {
  assistanceType?: AssistanceType;
  serviceId?: string;
  status?: RequestStatus;
  category?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export enum AssistanceType {
  Online = 'Online',
  Person = 'In_Person',
}

export enum ChatStatus {
  sent = 'sent',
  delivered = 'delivered',
  read = 'read',
}

export interface Chat {
  id: string;
  roomId: string;
  senderId: string;
  senderType: string;
  message: string;
  status: ChatStatus;
  media: ChatMedia[];
  createdAt: string;
  updatedAt: string;
}

export interface ChatMedia {
  id?: string;
  chatId: string | null;
  fileName: string;
  mimeType: string;
  fileSize: number;
  fileUrl: string;
  createdAt: string;
  updatedAt: string;
}

export interface Option {
  label: string;
  value: string;
  jumpTo?: string;
}

export interface Question {
  question: string;
  type: 'input' | 'options' | 'image';
  required: boolean;
  field: string;
  jumpTo: string;
  options?: Option[];
  dependsOn?: string;
}

export type GetRequestQuestionsResponse = {
  data: Question[];
};

export interface RequestComment {
  id: string;
  requestId: string;
  transferId?: string | null;
  userId?: string | null;
  comment: string;
  previousStatus?: RequestStatus | null;
  newStatus?: RequestStatus | null;
  commentType?: 'status_change' | 'transfer' | 'general' | null;
  createdAt: string;
  updatedAt: string;
}
